import * as React from "react"
import { gtmSignupStart } from "@/utils/gtm-tracking"

const ExternalSignUpButton = ({
  children,
  onClick,
  disabled,
  className,
  planName,
  gtm,
}) => {
  const handleClick = () => {
    // GTM tracking for external signup
    gtmSignupStart(planName, "Continue", gtm?.label || "")()

    onClick()
  }

  return (
    <button
      className={`btn btn--tertiary btn--full-width external-signup__button${
        className ? ` ${className}` : ""
      }`}
      disabled={disabled}
      onClick={handleClick}
    >
      <span className="external-signup__button-content">{children}</span>
    </button>
  )
}

export default ExternalSignUpButton
